// src/subscreens/admin/deleteConfirmation/DeleteConfirmation.jsx
import React from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import { AlertTriangle } from "lucide-react";
import "../../../assets/css/admin/deleteCofirmation/DeleteConfirmation.css";

const DeleteConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  productName,
  isDeleting = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Product"
      size="small"
    >
      <div className="delete-confirmation-content">
        <div className="warning-icon-wrapper">
          <AlertTriangle size={48} className="warning-icon" />
        </div>

        <div className="delete-message">
          <h3>Are you sure?</h3>
          <p>
            Do you really want to delete <strong>"{productName}"</strong>?
            <br />
            This action cannot be undone.
          </p>
        </div>

        <div className="delete-actions">
          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="delete-btn"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmation;
